<template>
  <section class="w-100 mockup-section px-2">
    <h2 class="title text-center mb-5">{{ title }}</h2>

    <b-row class="justify-content-md-center">
      <b-col
        ref="mockup-container"
        col
        md="10"
        lg="8"
        xl="6"
        class="position-relative p-0 mx-4 overflow-hidden mockup-col"
        :style="borderColor"
      >
        <div ref="effect-color" class="position-absolute color-effect h-100" :style="borderColor">
          <div class="h-100 w-100 overflow-hidden">
            <img
              :src="colorImg"
              :alt="colorImgAlt"
              class="h-100 width-unset"
              :width="reservedWidth"
              :height="reservedHeight"
              loading="lazy"
            />
          </div>
          <div
            v-hammer:pan.all="(event) => onPan(event)"
            v-hammer:panend="onPanEnd"
            :class="switchClass"
            :style="backgroundColor"
          >
            <div class="switch-icons d-flex">
              <Icon icon="bootstrap-chevron-left" class="mx-1" :width="16" :height="16" />
              <Icon icon="bootstrap-chevron-right" class="mx-1" :width="16" :height="16" />
            </div>
          </div>
        </div>
        <img
          :src="whiteImg"
          :alt="whiteImgAlt"
          class="w-100 h-100"
          :height="reservedHeight"
          :width="reservedWidth"
          loading="lazy"
        />
      </b-col>
    </b-row>
    <div class="row mx-0 w-100 d-flex justify-content-center align-items-center mt-5">
      <slot name="action-btn"></slot>
    </div>
  </section>
</template>

<script>
import Icon from 'UI/Icon';
import Vue from 'vue';
if (process.browser) {
  const { VueHammer } = require('vue2-hammer');
  Vue.use(VueHammer);
}

export default {
  name: 'MockupSection',
  components: {
    Icon
  },
  props: {
    title: {
      type: String,
      required: true
    },
    colorImg: {
      type: String,
      required: true
    },
    colorImgAlt: {
      type: String,
      required: false,
      default: 'Color Image'
    },
    whiteImg: {
      type: String,
      required: true
    },
    whiteImgAlt: {
      type: String,
      required: false,
      default: 'White Image'
    },
    color: {
      type: String,
      required: false,
      default: '#3f80f1'
    },
    reservedHeight: {
      type: Number,
      required: false,
      default: 606
    },
    reservedWidth: {
      type: Number,
      required: false,
      default: 927
    }
  },
  data() {
    return {
      initialWidth: 0
    };
  },
  computed: {
    borderColor() {
      return 'border-color: ' + this.color + ';';
    },
    backgroundColor() {
      return 'background-color: ' + this.color + ';';
    },
    switchClass() {
      var classList = [
        'switch',
        'position-absolute',
        'rounded-circle',
        'd-flex',
        'justify-content-center',
        'align-items-center'
      ];
      return classList.join(' ');
    }
  },
  mounted() {
    this.initialWidth = this.$refs['effect-color'].clientWidth;
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onPan(e) {
      if (e.type === 'panright' || e.type === 'panleft') {
        let absolute_width = e.deltaX + this.initialWidth;
        let percentage_width = (absolute_width * 100) / this.$refs['mockup-container'].clientWidth;
        if (percentage_width >= 0 && percentage_width <= 100)
          this.$refs['effect-color'].style.width = percentage_width + '%';
      }
    },
    onPanEnd() {
      this.initialWidth = this.$refs['effect-color'].clientWidth;
    },
    onResize() {
      this.initialWidth = this.$refs['effect-color'].clientWidth;
    }
  }
};
</script>

<style lang="scss" scoped>
.mockup-section {
  background-color: #f9f9f9;
  padding: 100px 0;
  @include sm {
    padding: 50px 0;
  }
  border-radius: 8px;
  .button-mockup {
    display: flex;
    @include sm {
      span {
        margin: 0 !important;
      }
      justify-content: center !important;
      padding: 0 0 10px;
    }
  }
}
.mockup-section > .title {
  font-size: 50px;
  font-weight: 500;
  @include md {
    font-size: 30px;
  }
}
.box {
  width: 25%;
  @include md {
    width: 50%;
  }
}
.box > .text-icon {
  font-size: 13px;
}
.box > .text-icon,
.box > span {
  font-weight: 500;
}
.mockup-col {
  border-style: solid;
  border-width: 2px;
  border-radius: 8px;
}
.color-effect {
  top: 0;
  left: 0;
  border-right-style: solid;
  border-right-width: 2px;
  width: 50%;
}
.switch {
  width: 60px;
  height: 60px;
  top: calc(50% - 30px);
  right: -30px;
  z-index: 3;
  @include md {
    width: 40px;
    height: 40px;
    top: calc(50% - 20px);
    right: -20px;
  }
}
.switch > .switch-icons {
  height: max-content;
  color: #ffffff;
}
.width-unset {
  width: unset;
}
</style>
